import { connect } from 'react-redux'
import PayPalCard from '../components/PayPalCard'
import * as api from '../../../actions/api'

const mapStateToProps = (state, ownProps) => {
  const { user, isAuthStateChange } = state.authentication
  const { settings } = state.settings
  return ({
    user,
    isAuthStateChange,
    settings
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleClickSwitch: (data) => {
      dispatch(api.user.update(data))
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PayPalCard)


// WEBPACK FOOTER //
// ./src/Parts/PayPalCard/containers/PayPalCard.js